import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const featureRequestSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getRequestTypesFilter: builder.query({
            query: () => {
                return {
                    url: constants.SEARCH_FEATURE_TYPES
                };
            },
        }),
        saveFeatureRequest: builder.mutation({
            query: (arg: any) => ({
                url: constants.FEATURE_REQUEST,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Post'],
        }),
    }),
});

export const {
    useGetRequestTypesFilterQuery,
    useSaveFeatureRequestMutation
} = featureRequestSlice;
